import React, { useEffect } from 'react'
import Skeleton from 'react-loading-skeleton'
import { hexToRgb } from '../utils/colors'
import { useSelector } from 'react-redux'
import { selectBrandColor } from '../store/base/commonSlice'
import { brandColor as DEFAULT_BRAND_COLOR } from '../style/brandConfig'
import { CSSProperties } from 'react'
import calculateLoadingColors from '../utils/calculateLoadingColors'

type Position = CSSProperties['position']

type LoadingScreenProps = {
  loading?: boolean
  children?: React.ReactNode
}
const LoadingScreen = ({ loading = false, children }: LoadingScreenProps) => {
  const [mobile, setMobile] = React.useState(false)
  const currentBrandColor = useSelector(selectBrandColor) || DEFAULT_BRAND_COLOR

  useEffect(() => {
    onResize()
    window.addEventListener('resize', onResize)
    return () => window.removeEventListener('resize', onResize)
  }, [])

  const onResize = () => {
    if (window.innerWidth <= 800) {
      if (!mobile) {
        setMobile(true)
      }
    } else {
      if (mobile) {
        setMobile(false)
      }
    }
  }

  const brandRGB = hexToRgb(currentBrandColor)
  const { highlightColor, darkBrandColor } = calculateLoadingColors(brandRGB)

  const screen = loading
    ? {
        opacity: 0,
        position: 'fixed' as Position,
        transform: 'scale(0.99) translateY(20px)',
      }
    : {
        opacity: 1,
        position: 'relative' as Position,
        transform: undefined,
      }

  const skeletonWrapper = mobile ? styles.mobileSkeletonWrapper : styles.skeletonWrapper

  return (
    <>
      <div id={'screenWrapper'} style={{ ...styles.screenWrapper, ...screen }}>
        {children}
      </div>
      {loading ? (
        <div style={skeletonWrapper}>
          <Skeleton
            count={1}
            height={24}
            borderRadius={12}
            highlightColor={highlightColor}
            baseColor={darkBrandColor}
            width={200}
            style={{
              lineHeight: 1,
              display: 'flex',
            }}
          />
          <Skeleton
            count={1}
            height={200}
            highlightColor={highlightColor}
            baseColor={darkBrandColor}
            style={{
              lineHeight: 1,
              marginBottom: 75,
              display: 'flex',
            }}
          />
          <Skeleton
            count={1}
            height={24}
            borderRadius={12}
            highlightColor={highlightColor}
            baseColor={darkBrandColor}
            width={200}
            style={{
              lineHeight: 1,
              display: 'flex',
            }}
          />
          <Skeleton
            count={1}
            height={200}
            highlightColor={highlightColor}
            baseColor={darkBrandColor}
            style={{
              lineHeight: 1,
              marginBottom: 75,
              display: 'flex',
            }}
          />
          <Skeleton
            count={1}
            height={24}
            borderRadius={12}
            highlightColor={highlightColor}
            baseColor={darkBrandColor}
            width={200}
            style={{
              lineHeight: 1,
              display: 'flex',
            }}
          />
          <Skeleton
            count={1}
            height={200}
            highlightColor={highlightColor}
            baseColor={darkBrandColor}
            style={{
              lineHeight: 1,
              marginBottom: 75,
              display: 'flex',
            }}
          />
        </div>
      ) : null}
    </>
  )
}

const styles = {
  skeletonWrapper: {
    paddingTop: 175,
    paddingLeft: 75,
    paddingRight: 75,
    paddingBottom: 100,
  },
  mobileSkeletonWrapper: {
    paddingTop: 90,
    paddingLeft: 36,
    paddingRight: 36,
    paddingBottom: 0,
  },
  screenWrapper: {
    opacity: 0,
    //overflow: 'hidden',
    position: 'absolute' as Position,
    transform: 'scale(0.99) translateY(20px)',
    transition: 'opacity 0.6s ease-out, transform 0.6s ease-out',
  },
}

export default LoadingScreen
